const green = {
  200: "#E3F3D3",
  400: "#C7E7A7",
  900: "#73C322",
  contrastDefaultColor: "#ffffff"
}
export default green
